// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"84":"20a1c7d3","453":"5d9839e6","574":"54379e88"}[chunkId] + ".chunk.js";
};